<div class="stt-container d-flex align-items-center">
    @if (enableAudioSourceSelector) {
    <div class="stt-split" [class.recording]="recording || dictationStatus === 'processing'"
        [class.idle]="!recording && dictationStatus !== 'processing'">
        <button type="button" class="stt-split-main"
            (click)="onMainButtonClick()"
            [disabled]="loading || dictationStatus === 'processing'"
            [title]="dictationStatus === 'processing' ? 'Processing...' : buttonLabel"
            [attr.id]="recording ? 'stopRecording' : 'startRecording'">
            @if (dictationStatus === 'processing' || loading) {
            <mat-progress-spinner class="stt-loader" [diameter]="16" mode="indeterminate"></mat-progress-spinner>
            @if (dictationStatus === 'processing') {
            <span class="stt-split-text">Processing...</span>
            }
            } @else {
            <mat-icon class="stt-split-icon">{{ audioSource === 'telehealth' ? 'screen_share' : 'mic' }}</mat-icon>
            <span class="stt-split-text">{{ buttonLabel }}</span>
            }
        </button>
        <div class="stt-split-divider"></div>
        <button type="button" class="stt-split-arrow" [matMenuTriggerFor]="sourceMenu"
            [disabled]="isDropdownDisabled" (click)="$event.stopPropagation()"
            aria-label="Select audio source">
            <mat-icon>expand_more</mat-icon>
        </button>
    </div>
    <mat-menu #sourceMenu="matMenu">
        @for (option of audioSourceOptions; track option.value) {
        <button mat-menu-item type="button" (click)="selectAudioSource(option)"
            [disabled]="option.disabled || isDropdownDisabled">
            {{ option.label }}
        </button>
        }
    </mat-menu>
    } @else {
    <button type="button" (click)="!recording ? startRecording() : stopRecording()"
        [disabled]="loading ||dictationStatus ==='processing'"
        [title]="dictationStatus ==='processing' ? 'Processing...' : (!recording ? 'Start Recording' : 'Stop Recording')"
        [class.btn-primary]="showLabel && !recording" [class.btn-danger]="showLabel && recording"
        [class.bg-primary]="!showLabel && !recording" [class.bg-danger]="!showLabel && recording"
        [class.stt-icon-button]="!showLabel" [class.stt-detection-button]="!showLabel && isDectation"
        [class.stt-small-button]="!showLabel && !isDectation" [attr.id]="recording ? 'stopRecording' : 'startRecording'"
        class="stt-button text-white d-flex align-items-center justify-content-center">

        @if(dictationStatus ==='processing'){
        @if (showLabel) {
        <span class="full-label me-2">Processing...</span>
        <span class="short-label me-2">Processing...</span>
        }

        <mat-progress-spinner class="stt-loader" [diameter]="16" mode="indeterminate" aria-label="Processing recording">
        </mat-progress-spinner>
        } @else if (recording) {

        @if (showLabel) {
        <span class="full-label me-2">Stop Recording</span>
        <span class="short-label me-2">Stop</span>
        }

        <svg class="stt-icon" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
            <circle class="stt-recording-dot" cx="12" cy="12" r="6" />
        </svg>

        } @else if (loading) {

        @if (showLabel) {
        <span class="full-label me-2">Start Recording</span>
        <span class="short-label me-2">Start</span>
        }

        <mat-progress-spinner class="stt-loader" [diameter]="16" mode="indeterminate">
        </mat-progress-spinner>

        } @else {

        @if (showLabel) {
        <span class="full-label me-2">Start Recording</span>
        <span class="short-label me-2">Start</span>
        }

        <svg class="stt-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 15a3 3 0 0 0 3-3V6a3 3 0 1 0-6 0v6a3 3 0 0 0 3 3Z" />
            <path d="M19 11a7 7 0 0 1-14 0" />
            <path d="M12 18v4" />
            <path d="M8 22h8" />
        </svg>

        }
    </button>
    }
</div>
